export default "\n<app-home-component></app-home-component>\n"